// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3SCss{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;height:30px;height:3rem;justify-content:center;width:30px;width:3rem}._3SCss:hover{opacity:.75}._3SCss:before{background:#30a8ff;border-radius:8px;bottom:0;content:\" \";left:0;opacity:.2;position:absolute;right:0;top:0}._3_JWx{fill:#30a8ff;height:16px;height:1.6rem;position:relative;width:16px;width:1.6rem}", ""]);
// Exports
exports.locals = {
	"link": "_3SCss",
	"link__icon": "_3_JWx"
};
module.exports = exports;
